import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { exists, filterInstances, MUSTNeverHappenException } from '@nu-art/ts-common';
import { DataGrid } from '@app/styles';
import { ModuleFE_PathwayState } from '../../../_entity/pathway-state/index.js';
import { ModuleFE_Action } from '../../../_entity/action/index.js';
import { ModuleFE_OrderGroup } from '../../../_entity/order-group/index.js';
import { Component_CollapsablePrettyPrint } from '../selectors/renderers/common-components/Component_CollapsablePrettyPrint.js';
import { Renderer_TransitionOrders } from './Renderer_TransitionOrders.js';
export class Renderer_Transitions extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // Check base class shouldComponentUpdate first
        const transitionsFromProps = this.props.transitions;
        const baseShouldUpdate = super.shouldComponentUpdate(nextProps, nextState, nextContext);
        if (baseShouldUpdate)
            return true;
        // always update if transitions array reference changed
        if (transitionsFromProps !== nextProps.transitions)
            return true;
        // check if transitions have been updated (using __updated timestamp or length change)
        if (transitionsFromProps.length !== nextProps.transitions.length)
            return true;
        // check if any transition has been updated or changed
        transitionsFromProps.forEach((transition, i) => {
            const next = nextProps.transitions[i];
            if (!next || transition._id !== next._id || transition.__updated !== next.__updated)
                return true;
        });
        return false;
    }
    render() {
        const { transitions, isFromState, functions } = this.props;
        _jsx(DataGrid.Label, { children: isFromState ? `Transitions` : '' });
        return _jsx(_Fragment, { children: !transitions.length ?
                _jsx(DataGrid.Data, { children: "-" }) :
                _jsx(LL_V_L, { style: { padding: '6px' }, children: transitions.map(transition => {
                        const targetState = ModuleFE_PathwayState.cache.unique(transition.targetId);
                        if (!targetState)
                            throw new MUSTNeverHappenException(`Could not find target state with id ${transition.targetId}`);
                        let transitionName = exists(transition.label) ? transition.label : targetState.name;
                        if (!isFromState)
                            transitionName += ` to ${targetState.name}`;
                        const preconditionOrders = targetState.preconditions.map(precon => precon.itemPointer)?.map((pointer, index) => {
                            switch (pointer?.dbKey) {
                                case DBDef_Action.dbKey: {
                                    const order = ModuleFE_Action.cache.unique(pointer.id);
                                    if (!order)
                                        return;
                                    return order?.label ?? order.name;
                                }
                                case DBDef_OrderGroup.dbKey: {
                                    const group = ModuleFE_OrderGroup.cache.unique(pointer.id);
                                    if (!group)
                                        return;
                                    return group?.label ?? group.name;
                                }
                            }
                        });
                        const preconditionsString = preconditionOrders.length ? ` [${filterInstances(preconditionOrders).join(', ')}]` : '';
                        return _jsx(DataGrid.Data, { children: _jsxs(LL_V_L, { children: [_jsx("div", { className: 'grid-label-with-items', onClick: () => this.props.functions.selectPathwayTransition(transition._id), children: transitionName + preconditionsString }), _jsx(Component_CollapsablePrettyPrint, { functions: functions, transitionId: transition._id }), _jsx(Renderer_TransitionOrders, { transition: transition })] }) }, transition._id);
                    }) }) });
    }
}
//# sourceMappingURL=Renderer_Transitions.js.map